var Stat = require('fs').Stats

module.exports = cloneStats

function cloneStats(stats) {
  var replacement = new Stat

  Object.keys(stats).forEach(function(key) {
    replacement[key] = stats[key]
  })

  return replacement
}



//////////////////
// WEBPACK FOOTER
// ./~/clone-stats/index.js
// module id = 2333
// module chunks = 0